<template>
    <div>
  
      <el-row style="margin-bottom:10px;">
        <el-col :span="18" class='flex'>
          <el-input
            v-model="getSysSensitiveList_data.senName"
            placeholder="请输入敏感词名"
            clearable
            size='small'
            style="max-width:380px;"/>
          <el-button
            v-click.getSysSensitiveList
            type="primary"
            icon='el-icon-search'
            size='small'
            style='margin-left:10px;'
          >搜索
          </el-button>
        </el-col>
        <el-col :span="6" >
          <el-button
            v-if='addSysSensitive'
            @click="$form('addSysSensitive') "
            size='small'
            type="primary"
            style="float:right"
            icon='el-icon-circle-plus'
          >添加敏感词
          </el-button>
        </el-col>
      </el-row>
  
      <mytable
        :tableColums='tableColums_getSysSensitiveList'
        api='getSysSensitiveList'
        updateapi='updateSysSensitive'
        :height="H-165" >
      </mytable> 
  
      <myform
        :viewobj='{
          addSysSensitive:    [ "新增敏感词信息", "el-icon-circle-plus" ],
          updateSysSensitive: [ "修改敏感词信息", "el-icon-edit-outline"],
          $succeed$: getSysSensitiveList
        }'
        @close='$form("addSysSensitive","reset")' >

        <template v-slot:classify="{ Myformdata }">
        <el-select v-model='Myformdata.classify' clearable>
          <el-option v-for="item in getSysSensitiveClassList_data.data || []" :key="item.mtId" :label="item.mtName"
            :value="item.classify">
          </el-option>
        </el-select>
      </template>
        <hide slot='ssId' />
      </myform>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        vtId: null,
  
        tableColums_getSysSensitiveList: {
          $selection: false,
  
          senName: '敏感词',
  
          classify: '分类',
  
          // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],
  
          $operation: [
            '操作', 200,
            this.updateSysSensitive && `@text: 编辑#success
             @click: $form("updateSysSensitive",$row)
            `,
            this.deleteSysSensitive && `@text: 删除#danger
             @click: _confirm('确定要删除该敏感词吗?')
                     .trigger('deleteSysSensitive',{ssIds:$row.ssId})
                     .trigger('getSysSensitiveList')
            `,
          ],
  
        },
  
      };
    },
  
    watch: {
      
    },
  
    methods: {},
  
    created() {
      this.getSysSensitiveList();
      this.getSysSensitiveClassList()
    }
  };
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/rule/sensitive.vue